import { useState } from "react";
import { useAuth } from "../Context/AuthContext";

export default function BranchSwitcher() {
  const { user, branchId, accessibleBranches, canSwitchBranch } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!user) return null;
  if (user.role !== "staff") return <span className="rounded-xl border border-white/10 px-3 py-2 text-xs text-amber-400">All branches</span>;
  const switchBranch = async (value) => {
    if (busy || Number(value) === Number(branchId)) return;
    if (!window.confirm("Switch branch? Unsaved changes on this page will be lost.")) return;
    setBusy(true); setError("");
    try {
      const api = process.env.REACT_APP_API_URL || (["localhost", "127.0.0.1"].includes(window.location.hostname) ? "/api" : "/api");
      const response = await fetch(`${api}/admin/active-branch`, { method:"POST", credentials:"include",
        headers:{"Content-Type":"application/json"}, body:JSON.stringify({branch_id:Number(value)}) });
      const data = await response.json();
      if (!response.ok || data.status !== "success") throw new Error(data.detail || data.message || "Could not switch branch");
      window.location.reload();
    } catch (err) { setError(err.message); setBusy(false); }
  };
  return <div className="relative max-w-56">
    <label className="sr-only" htmlFor="active-branch">Current branch</label>
    <select id="active-branch" value={branchId || ""} disabled={busy || !canSwitchBranch}
      onChange={(e) => switchBranch(e.target.value)}
      className="max-w-full rounded-xl border border-amber-400/20 bg-[#0b0b0f] px-3 py-2 text-xs text-amber-400 disabled:opacity-80">
      {accessibleBranches.map((branch) => <option key={branch.id} value={branch.id}>{branch.name}</option>)}
    </select>
    {error && <p role="alert" className="absolute right-0 top-full mt-2 w-64 rounded-lg border border-red-400/30 bg-[#0b0b0f] p-3 text-xs text-red-300">{error}</p>}
  </div>;
}
